import { render } from "./CartIcon.vue?vue&type=template&id=7962ddac&scoped=true&ts=true"
import script from "./CartIcon.vue?vue&type=script&lang=ts"
export * from "./CartIcon.vue?vue&type=script&lang=ts"

import "./CartIcon.vue?vue&type=style&index=0&id=7962ddac&scoped=true&lang=css"

import exportComponent from "/tmp/momo-store-main/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7962ddac"]])

export default __exports__